export const useQueryStringRemover = () => {
  const removeParam = (key: string) => {
    const to = useRoute();
    const tmpQuery = Object.fromEntries(Object.entries(to.query).filter(([k]) => k !== key));
    useRouter().push({ query: tmpQuery });
  };

  const removeAll = () => {
    useRouter().push({ query: {} });
  };

  return { removeParam, removeAll };
};
